<div *ngIf="view=='request'">
  <app-button class="small mr-1" [loading]="loading" label="Queue for Disbursement" (click)="queueForDisbursement()">
  </app-button>
  
</div>